import { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

function BarChart(props) {
    const chartRef = useRef(null);
    const chartInstance = useRef(null);

    useEffect(() => {
        if(chartInstance.current) {
            chartInstance.current.destroy();
        }

        const ctx = chartRef.current.getContext('2d');
        console.log(props)
        chartInstance.current = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: props.weeks.map((date) =>date),
                datasets: [{
                    label: '',
                    data: props.resultsArray,
                    backgroundColor: ['#31d4be', '#d4c131'],
                    hoverOffset: 0
                }]
            },
            options: {
                scales: {
                    y: {
                      beginAtZero: true
                    }
                }
            }
        });

        return () => {
            if(chartInstance.current) {
                chartInstance.current.destroy();
            }
        };
    }, []);

    return (
        <canvas style={{width: '100%'}} ref={chartRef}></canvas>
    )
}

export default BarChart;